import React, {useState, useEffect} from "react";
import {useSelector} from "react-redux";
import {
    getOptionsByCommaString, isEmpty
} from "../../../../../_helpers/commonFunctions";
import EditableTable from "../../../../primer/Editable-Table";
import {Col, Row} from "react-bootstrap";
import {toast} from "react-toastify";
import DateBox from "../../../../primer/DateBox";
import Dropdown from "../../../../primer/Dropdown";
import {setSaveEditSupplier} from "../../../../../_reducers/activitySlice";
import {
    resetNewCommunicationHistory,
    setEditSupplier,
    setNewCommunicationHistory,
} from "../../../../../_reducers/DataPanel/Suppliers/supplierSlice";
import moment from "moment";
import useTaggedDispatch from "../../../../../hooks/useTaggedDispatch";
import {useTranslation} from "../../../../../hooks/useTranslation";

const EditSupplierCommunicationHistory = ({tabKey}) => {
    const {t} = useTranslation();
    const dispatch = useTaggedDispatch({tabKey});
    const saveEditSupplier = useSelector((state) => state.ACTIVITY.saveEditSupplier);
    const SUPPLIERS_DATA = useSelector((state) => state.SUPPLIERS_DATA);
    const editSupplier = useSelector((state) => state.SUPPLIERS_DATA.editSupplier[tabKey]);
    const subjectsOptions = getOptionsByCommaString(SUPPLIERS_DATA.suppliersSettings.supplierCommunicationHistory);

    const communicationHistoryFilters = editSupplier?.communicationHistoryFilters || {};

    const [incrKey, setIncrKey] = useState(0);
    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [editSupplier?.communicationHistory])

    const chColumns = [
        {
            name: "Αρ.",
            field: "no",
            width: "15px",
            editable: false,
        },
        {
            name: t('ClientsNewCommunicationHistoryEdit.table1.date'),
            field: "date",
            width: "80px",
            editable: true,
            inputType: {
                type: 'datebox',
            }
        },
        {
            name: t('ClientsNewCommunicationHistoryEdit.table1.time'),
            field: "time",
            width: "50px",
            editable: true,
            inputType: {
                type: 'time',
            }
        },
        {
            name: t('ClientsNewCommunicationHistoryEdit.table1.subject'),
            field: "subject",
            width: "100px",
            editable: true,
            inputType: {
                type: 'dropdown',
                options: subjectsOptions
            }
        },
        {
            name: t('ClientsNewCommunicationHistoryEdit.table1.details'),
            field: "details",
            editable: true,
            width: "400px",
            inputType: {
                type: 'textarea',
            }
        },
    ]

    const handleOnFilterChange = (e, type = "default", ddname = '') => {
        const prepFilters = {...communicationHistoryFilters};

        let name;
        let value;
        if (type === "msdd") {
            name = ddname;
            value = e.flatMap((o) => o.value);
        } else if (type === "dd") {
            name = ddname;
            value = e.value;
        } else if (type === "dp") {
            value = e;
            name = ddname;
        } else {
            name = e.target.name;
            value = e.target.value;
        }
        prepFilters[name] = value;

        dispatch(setEditSupplier({...editSupplier, communicationHistoryFilters: prepFilters}));
        setIncrKey(incrKey + 1);
    }

    const tableActions = {
        insert: (e, data) => {
            if (!saveEditSupplier) dispatch(setSaveEditSupplier(true));

            const tempCommunicationHistory = {...SUPPLIERS_DATA.newCommunicationHistory};
            tempCommunicationHistory[data.field] = data.value;
            dispatch(setNewCommunicationHistory(tempCommunicationHistory));
            if (tempCommunicationHistory && !isEmpty(tempCommunicationHistory.subject) && !isEmpty(tempCommunicationHistory.details) && tempCommunicationHistory.date && tempCommunicationHistory.time) {
                const cloneIt = structuredClone([tempCommunicationHistory, ...structuredClone(editSupplier?.communicationHistory || [])]);
                cloneIt.forEach((row, idx) => {
                    row.id = idx + 1;
                    row.no = idx + 1;
                })
                dispatch(setEditSupplier({...editSupplier, communicationHistory: cloneIt}));
                dispatch(resetNewCommunicationHistory());
            }
        },
        update: (data, id) => {
            if (!saveEditSupplier) dispatch(setSaveEditSupplier(true));

            if (data.date && (data.date === "")) {
                toast.error("Date is mandatory field.");
            } else if (data.time && (data.time === "")) {
                toast.error("Time  is mandatory field.");
            } else {
                const cloneIt = editSupplier.communicationHistory.slice();
                const rowIndex = cloneIt.findIndex((el) => String(el.no) === String(id));
                if (rowIndex >= 0) {
                    cloneIt[rowIndex] = {...cloneIt[rowIndex], ...data};
                    dispatch(setEditSupplier({...editSupplier, communicationHistory: cloneIt}));
                }
            }
        },
        selected: () => {},
        delete: (id, rowIndex, rowData) => {
            if (!saveEditSupplier) dispatch(setSaveEditSupplier(true));

            const cloneIt = structuredClone(editSupplier.communicationHistory);
            const idx = cloneIt.findIndex((el) => String(el.no) === String(rowData.no));
            if (idx >= 0) {
                cloneIt.splice(idx, 1);
                cloneIt.forEach((row, idx) => {
                    row.id = idx + 1;
                    row.no = idx + 1;
                })
                dispatch(setEditSupplier({...editSupplier, communicationHistory: cloneIt}));
            }
        }
    }

    const getDisplayData = () => {
        let data = (editSupplier?.communicationHistory || []).slice();

        if (communicationHistoryFilters?.dateFrom) data = data.filter((el) => moment(el.date) > moment(communicationHistoryFilters.dateFrom));
        if (communicationHistoryFilters?.dateTo) data = data.filter((el) => moment(el.date) < moment(communicationHistoryFilters.dateTo));
        if (communicationHistoryFilters?.subject?.length > 0) data = data.filter((el) => communicationHistoryFilters.subject.includes(el.subject));

        return data;
    }

    return (
        <div>
            <Row>
                <Col md={4}>
                    <DateBox
                        name="dateFrom"
                        selected={communicationHistoryFilters?.dateFrom}
                        allowOtherYears={true}
                        label={t('ClientsNewCommunicationHistoryEdit.dateFrom')}
                        onChange={(date) => handleOnFilterChange(date, 'dp', 'dateFrom')}
                    />
                </Col>
                <Col md={4}>
                    <DateBox
                        name="dateTo"
                        selected={communicationHistoryFilters?.dateTo}
                        allowOtherYears={true}
                        label={t('ClientsNewCommunicationHistoryEdit.dateTo')}
                        onChange={(date) => handleOnFilterChange(date, 'dp', 'dateTo')}
                    />
                </Col>
                <Col md={4}>
                    <Dropdown
                        multiSelect={true}
                        label={t('ClientsNewCommunicationHistoryEdit.subject')}
                        name="subject"
                        options={subjectsOptions}
                        key={communicationHistoryFilters.subject}
                        defaultValue={subjectsOptions.filter((el) => communicationHistoryFilters?.subject?.includes(el.value))}
                        onChange={(e) => handleOnFilterChange(e, 'msdd', 'subject')}
                    />
                </Col>
            </Row>
            <EditableTable
                className="supplier-communication-history"
                tableName="Supplier Communication History"
                allowActions={true}
                key={incrKey}
                actionButtons={{
                    edit: false,
                    print: false,
                    export: false,
                    delete: true,
                }}
                allowFilter={false}
                allowPagination={false}
                allowBulkActions={false}
                allowPrintResults={false}
                columns={chColumns}
                allowInsertRowFromTop={true}
                allowFilterTable={false}
                data={getDisplayData()}
                onUpdate={tableActions}
                enableNewRowCheckbox={true}
            />
        </div>
    )
}

export default EditSupplierCommunicationHistory;
